import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, HostListener } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'file-uploader',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: FileUploaderComponent,
      multi: true
    }
  ],
  template: `
  <div>
    <label-text>{{ acceptFile === 'audio' ? 'Audio File' : 'Image File' }}</label-text>
    <warning-text *ngIf="acceptFile === 'image'">(KEEP UNTOUCHED IF ITS THE SAME FILE)</warning-text>
    <div>  
      <button class="btn btn-file" (click)="onFileOpen()">
        <i class="fa mr-2 {{ acceptFile === 'audio' ? 'fa-microphone' : 'fa-image' }}" aria-hidden="true"></i>Choose File
      </button>
      <input #fileUploader type="file" accept="{{ acceptFile === 'audio' ? 'audio/*' : 'image/*' }}" (change)="changeHandler($event)">
      <span class="text-d200 ml-3 h4-m">{{ fileName || 'No File Choosen' }}</span>
    </div>
  </div>`,
  styleUrls: ['./file-uploader.component.css']
})
export class FileUploaderComponent implements OnInit,ControlValueAccessor {
  @Input() acceptFile
  @Output() setFile: any = new EventEmitter<any>()
  @ViewChild('fileUploader', undefined) fileUploader: ElementRef
  fileName: String = null

  constructor(private host: ElementRef<HTMLInputElement> ) { }

  ngOnInit() {
  }

  onChange: Function;
  private file: File | null = null;

  @HostListener('change', ['$event.target.files']) emitFiles( event: FileList ) {
    const file = event && event.item(0);
    this.onChange(file);
    this.file = file;
  }

  

  writeValue( value: null ) {
    // clear file input
    this.host.nativeElement.value = '';
    this.file = null;
  }

  registerOnChange( fn: Function ) {
    this.onChange = fn;
  }

  registerOnTouched( fn: Function ) {
  }

  onFileOpen() {
    this.fileUploader.nativeElement.value = null
    this.fileUploader.nativeElement.click()
  }

  changeHandler(e) {
    let selectFiles = e.dataTransfer ? e.dataTransfer.files : e.target.files
    let file = selectFiles[0];

    if(!file) return

    this.fileName = file.name
    this.setFile.emit(file)   
  }


}
